module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAFVBMVEUAAAC+GTG+GTG+GTG+GTG+GTG+GTGgxwOeAAAAB3RSTlMAIJ/v/wAwF8MKgAAAAGVJREFUeAFjGCggZOKsGAoHKDwGGCPMxMXFORWVh6FI2AUIDFF5GIpUQMJOqDwMRSYgYWdUHoYiFzBA5Q1+RaOKRhWNKhpVNKqIcGFPuNogXAGRV5WF4q0UcYOBVzRam4+mJ7wAAI2P/7b50WKtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/203c.png
// module id = 1312
// module chunks = 0